/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq */
import React, {useState, useEffect, useRef} from 'react';
import _ from 'lodash';
import { IonPage, IonContent, IonHeader, IonTitle, IonToolbar, isPlatform, IonAlert, IonCard, IonCardContent, IonButtons, IonMenuButton, IonText } from '@ionic/react';
import './ScanScreen.scss';
import QrReader from 'react-qr-reader';
import { detect } from 'detect-browser';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {findTrip, findTripByShipmentNumber, updateTrip, UPDATE_TRIP, FIND_TRIP, FIND_TRIP_BY_SHIPMENT_NUMBER} from '../../../../actions/trip';
import Preloader from '../../../../components/Preloader';
import moment from 'moment';
import 'moment/locale/id'; // import locale Indonesia
import {areTripOrdersLoaded, validateQR} from './validator';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const browser = detect();
const USER_PAYLOAD_KEY = 'USER_PAYLOAD';

const parseJSON = (value, fallback = null) => {
  if (!value) {
    return fallback;
  }

  if (typeof value === 'object') {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return fallback;
  }
};

const ScanScreen = ({findTrip, findTripByShipmentNumber, updateTrip, trip, history, user}) => {
  const { t } = useTranslation();
  const [tripId, setTripId] = useState(null);
  const [isQrError, setIsQrError] = useState('');
  const [isSupported, setIsSupported] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [alertContent, setAlertContent] = useState({
    header: '',
    message: '',
    buttons: ['Ok'],
  });
  const [showAlternative, setShowAlternative] = useState(false);
  const userPayload = typeof window !== 'undefined'
    ? parseJSON(window.localStorage.getItem(USER_PAYLOAD_KEY), null)
    : null;
  const companySettings = parseJSON(_.get(userPayload || user, 'company.config.settings'), {});
  const isUserSecurityCheckActive = _.get(companySettings, 'mshipper.security_check.is_active', false);
  const isShowSealNumberActive = _.get(companySettings, 'mshipper.show_seal_number.is_active', false);
  const tripPopulate = [
    'vehicle',
    'driver',
    'vehicle_type',
    'orders',
    'company_shipper',
    ...(isShowSealNumberActive ? ['company_transport'] : []),
  ].join(',');
  const shouldValidateLoadedBeforeDepart = currentTrip => {
    const supergroup = _.get(currentTrip, 'company_shipper.supergroup') || user.supergroup;

    return supergroup === 'sasa';
  };
  const shouldShowSealFields = () => isShowSealNumberActive;
  const renderAlertField = (label, value) => `
    <p class="text-muted">${label}</p>
    <p>${value || '-'}</p>
    <br />
  `;
  const buildTripAlertMessage = (currentTrip, statusLabel, statusValue) => {
    const commonFields = [
      renderAlertField(t('shipment_number'), currentTrip.shipment_number),
    ];

    if (shouldShowSealFields()) {
      commonFields.push(
        renderAlertField(t('license_plate'), _.get(currentTrip, 'vehicle.license_plate', '-')),
        renderAlertField(t('vendor_name'), _.get(currentTrip, 'company_transport.name', '-')),
        renderAlertField(t('driver_name'), _.get(currentTrip, 'driver.name', '-')),
        renderAlertField(t('seal_number'), currentTrip.seal_number),
        renderAlertField(t('container_number'), currentTrip.container_number),
      );
    } else {
      commonFields.push(
        renderAlertField(t('driver'), _.get(currentTrip, 'driver.name', '-')),
        renderAlertField(t('vehicle'), `${_.get(currentTrip, 'vehicle_type.name', '')} - ${_.get(currentTrip, 'vehicle.license_plate', '-')}`),
      );
    }

    commonFields.push(renderAlertField(statusLabel, statusValue));

    return `
      <div class="alert-custom">
        ${commonFields.join('')}
      </div>
    `;
  };
  const showTripAlert = (currentTrip, gateDetails, buttons) => {
    setAlertContent({
      onDidDismiss: () => setShowAlert(false),
      header: gateDetails.header,
      message: buildTripAlertMessage(currentTrip, gateDetails.statusLabel, gateDetails.statusValue),
      buttons,
    });
    setShowAlert(true);
  };
  const getTripGateDetails = (currentTrip) => {
    let body = {};
    let header = t('truck_depart_success');
    let statusLabel = t('gate_in');
    let isGateIn = false;
    let statusValue = user.company_id == currentTrip.company_shipper_id
      ? moment(currentTrip.origin_gate_in).local().format('dddd, DD MMMM YYYY, HH:mm')
      : moment(currentTrip.destination_gate_in).local().format('dddd, DD MMMM YYYY, HH:mm');

    if (currentTrip.id) {
      const {origin_gate_in, origin_gate_out, destination_gate_in, destination_gate_out} = currentTrip;

      if (!origin_gate_in && user.company_id == currentTrip.company_shipper_id) {
        body.origin_gate_in = moment().utc();
        header = t('truck_registered_success');
        statusLabel = t('truck_registered');
        isGateIn = true;
        statusValue = moment(body.origin_gate_in).local().locale('id').format('dddd, DD MMMM YYYY, HH:mm');
      } else if (!origin_gate_out && user.company_id == currentTrip.company_shipper_id) {
        if (shouldValidateLoadedBeforeDepart(currentTrip) && !areTripOrdersLoaded(currentTrip)) {
          return {
            body,
            header: t('failed'),
            statusLabel,
            statusValue,
            isGateIn,
            hasPendingUpdate: false,
            errorMessage: t('truck_depart_order_must_be_loaded'),
          };
        }

        body.origin_gate_out = moment().utc();
        header = t('truck_depart_success');
        statusLabel = t('truck_depart');
        statusValue = moment(body.origin_gate_out).local().format('dddd, DD MMMM YYYY, HH:mm');
      } else if (!destination_gate_in && user.company_id != currentTrip.company_shipper_id) {
        body.destination_gate_in = moment().utc();
        header = t('truck_registered_success');
        statusLabel = t('truck_registered');
        isGateIn = true;
        statusValue = moment(body.origin_gate_in).local().locale('id').format('dddd, DD MMMM YYYY, HH:mm');
      } else if (destination_gate_in && !destination_gate_out && user.company_id != currentTrip.company_shipper_id) {
        body.destination_gate_out = moment().utc();
        header = t('truck_depart_success');
        statusLabel = t('truck_depart');
        statusValue = moment(body.destination_gate_out).local().format('dddd, DD MMMM YYYY, HH:mm');
      }
    }

    return {
      body,
      header,
      statusLabel,
      statusValue,
      isGateIn,
      hasPendingUpdate: !_.isEmpty(body),
    };
  };
  const showValidationAlert = (message) => {
    setAlertContent({
      onDidDismiss: () => setShowAlert(false),
      header: t('failed'),
      message,
      buttons: [t('ok')],
    });
    setShowAlert(true);
  };
  const persistTripGateUpdate = (currentTrip, gateDetails, extraBody = {}, onSuccess) => {
    const currentTripId = _.get(currentTrip, 'id');
    const payload = {
      ...gateDetails.body,
      ...extraBody,
    };

    if (!currentTripId || _.isEmpty(payload)) {
      return;
    }

    updateTrip(currentTripId, payload).then((res) => {
      if (res.type === `${UPDATE_TRIP}_SUCCESS`) {
        const data = _.get(res, 'payload.data', {});
        if (data.errorMessage) {
          setAlertContent({
            onDidDismiss: () => setShowAlert(false),
            header: t('failed'),
            message: data.errorMessage,
            buttons: [t('ok')],
          });
          setShowAlert(true);
        } else if (onSuccess) {
          onSuccess();
        }
      } else {
        setAlertContent({
          onDidDismiss: () => setShowAlert(false),
          header: t('failed'),
          message: _.get(res, 'error.response.data.errorMessage', t('unknown_error')),
          buttons: [t('ok')],
        });
        setShowAlert(true);
      }
    });
  };
  const handleRejectDriver = (currentTrip, gateDetails) => {
    persistTripGateUpdate(currentTrip, gateDetails, { gate_status: 'rejected' });
  };
  const handleAcceptDriver = (currentTrip, gateDetails) => {
    persistTripGateUpdate(currentTrip, gateDetails);
  };
  const getSuccessButtons = (currentTrip, gateDetails) => (
    isUserSecurityCheckActive && gateDetails.isGateIn
      ? [
          {
            text: t('reject_driver'),
            role: 'cancel',
            handler: () => handleRejectDriver(currentTrip, gateDetails),
          },
          {
            text: t('accept_driver'),
            cssClass: 'accept-driver-button',
            handler: () => handleAcceptDriver(currentTrip, gateDetails),
          },
        ]
      : [t('ok')]
  );

  useEffect(() => {
    if (browser && browser.name) {
      if (isPlatform('ios') && !browser.name !== 'safari') {
        setIsSupported(false);
      }
    }
  }, []);

  useEffect(() => {
    if (trip.trip) {
      if (trip.trip.errorMessage) {
        setAlertContent({
          onDidDismiss: () => setShowAlert(false),
          header: t('error_occurred'),
          message: trip.trip.errorMessage,
          buttons: [t('ok')],
        });
        setShowAlert(true);
      } else {
        if (isUserSecurityCheckActive) {
          promptTripGateTime(trip.trip);
        } else {
          updateTripGateTime(trip.trip);
        }
      }
    }
  }, [trip.trip, isUserSecurityCheckActive]);

  /**
   * Update trip gate in / out time
   * @return {[type]} [description]
   */
  const updateTripGateTime = (trip) => {
    if (trip.id) {
      const gateDetails = getTripGateDetails(trip);
      if (gateDetails.errorMessage) {
        showValidationAlert(gateDetails.errorMessage);
        return false;
      }

      if (!gateDetails.hasPendingUpdate) {
        showTripAlert(trip, gateDetails, ['Ok']);
        return false;
      }

      persistTripGateUpdate(trip, gateDetails, {}, () => {
        showTripAlert(trip, gateDetails, ['Ok']);
      });
    }
  }
  const promptTripGateTime = (trip) => {
    if (trip.id) {
      const gateDetails = getTripGateDetails(trip);
      if (gateDetails.errorMessage) {
        showValidationAlert(gateDetails.errorMessage);
      } else if (!gateDetails.hasPendingUpdate) {
        showTripAlert(trip, gateDetails, ['Ok']);
      } else if (gateDetails.isGateIn) {
        showTripAlert(trip, gateDetails, getSuccessButtons(trip, gateDetails));
      } else {
        persistTripGateUpdate(trip, gateDetails, {}, () => {
          showTripAlert(trip, gateDetails, ['Ok']);
        });
      }
    }
  }


  const isFindingTrip = useRef(false);
  const lockTimeout = useRef(null);

  useEffect(() => () => {
    if (lockTimeout.current) {
      clearTimeout(lockTimeout.current);
    }
  }, []);

  const handleScan = data => {
    if (isFindingTrip.current) return;

    if (data) {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }

      if (validateQR(data, process.env.REACT_APP_KEY)) {
        isFindingTrip.current = true;

        findTrip(data.data.value, { populate: tripPopulate })
          .then(res => {
            if (res.type === `${FIND_TRIP}_FAIL` && res.error && res.error.response) {
              if (res.error.response.status === 401) {
                history.push('/login');
                setAlertContent({
                  onDidDismiss: () => setShowAlert(false),
                  header: t('session_expired'),
                  message: t('login_again'),
                  buttons: [t('ok')],
                });
                setShowAlert(true);
              } else {
                setAlertContent({
                  onDidDismiss: () => setShowAlert(false),
                  message: t('unknown_error'),
                  buttons: [t('ok')],
                });
                setShowAlert(true);
              }
            } else {
              setTripId(data.data.value);
            }
          })
          .finally(() => {
            lockTimeout.current = setTimeout(() => {
              isFindingTrip.current = false;
              lockTimeout.current = null;
            }, 1000);
          });
      } else {
        setAlertContent({
          onDidDismiss: () => {
            setShowAlert(false);
            setShowAlternative(true);
          },
          header: t('error_occurred'),
          message: t('invalid_qr'),
          buttons: [t('try_again')],
        });
        setShowAlert(true);
      }
    }
  };

  const handleError = err => {
    setIsQrError(err);
    setAlertContent({
      onDidDismiss: () => setShowAlert(false),
      header: t('cannot_read_qr'),
      message: `${t('allow_camera')} ${err}`,
      buttons: [t('ok')],
    });
    setShowAlert(true);
  }

  const modalConfirmShipmentNumber = async () => {
    const { value: shipment_number } = await Swal.fire({
      icon: 'info',
      text: t('enter_shipment_number'),
      input: 'text',
      showCancelButton: true,
      confirmButtonText: t('submit'),
      showLoaderOnConfirm: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value.length > 0) {
            resolve()
          } else {
            resolve(t('invalid_shipment_number'))
          }
        })
      }
    })
    if (!shipment_number) {
      return;
    }
    findTripByShipmentNumber(shipment_number, { populate: tripPopulate }).then(res => {
      if (res.type === `${FIND_TRIP_BY_SHIPMENT_NUMBER}_FAIL` && res.error && res.error.response) {
        switch (res.error.response.status) {
          case 401:
            history.push('/login');
            setAlertContent({
              onDidDismiss: () => setShowAlert(false),
              header: t('session_expired'),
              message: t('login_again'),
              buttons: [t('ok')],
            });
            setShowAlert(true);
            break;
          default:
          setAlertContent({
            onDidDismiss: () => setShowAlert(false),
            message: t('unknown_error'),
            buttons: [t('ok')],
          });
          setShowAlert(true);
        }
      }
    });
  }

  return (
    <IonPage className="scan-page">
      {trip.loading.findTrip || trip.loading.updateTrip ? <Preloader /> : null}
      <IonAlert
        cssClass="scan-trip-alert"
        isOpen={showAlert}
        {...alertContent}
      />
      <IonHeader>
        <IonToolbar className="ritase-toolbar" color="primary">
          <IonButtons slot="start">
            <IonMenuButton auto-hide="true"></IonMenuButton>
          </IonButtons>
        <IonTitle style={{ textAlign: 'left', marginLeft: '-30px'}}>{t('scan')}</IonTitle>
          <IonButtons slot="end">
            <LanguageSwitcher />
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        {!isQrError && <h5 style={{marginTop: 76}}>{t('scan_activity')}</h5>}

        {!isQrError && <QrReader
          delay={1000}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '100%' }}
        />}

        {!isQrError && <p>{t('point_qr_code')}</p>}
        {isQrError &&  `${t('error_occurred')} ${isQrError}`}
        {showAlternative && (
          <>
            <IonCard onClick={modalConfirmShipmentNumber}>
              <IonCardContent>
                <p>{t('scan_difficulty')}</p>
              </IonCardContent>
            </IonCard>
          </>
        )}
      </IonContent>
    </IonPage>
  );
}

const mapstp = ({trip, user}) => {
  return {
    trip,
    user: user.data
  }
};
const mapdtp = dispatch => bindActionCreators({findTrip, updateTrip, findTripByShipmentNumber}, dispatch);

export default connect(mapstp, mapdtp)(ScanScreen);
